import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
};

const initialState = {
	lotto_miniState: {
		ticket_numbers: ''
	},
	lotto_aff: {
		idev: ''
	}
};

const state_reducer = (state = initialState, action) => {
	switch (action.type) {
		case "LOTTO_MINI":
			return {
				...state,
				lotto_miniState: {
					...state.lotto_miniState,
					...action.payload,
				},
			};
		case "LOTTO_PAWA_AFF":
			return {
				...state,
				lotto_aff: {
					...state.lotto_aff,
					...action.payload,
				},
			};
		case "RESET_LOTTO_PAWA":
            return {
                ...state,
                lotto_miniState: { ...initialState.lotto_miniState }
            };
		default:
			return state;
	}
};

const rootReducer = combineReducers({
    state: state_reducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export default store;
